import { gql } from "@apollo/client";
import {TypeDefinitionAttributeFields} from "../fragments/typeDefinitionAttribute";

export const InstalledBaseNodeAttributeOptionValueListTDAs = gql`
    query InstalledBaseNodeAttributeOptionValueListTDAs ($id: ID!, $typeDefinitionIndex: PropertyOptionValueTypeDefinitionIndex!) {
        installedBaseNodePropertyOptionValueList (propertyId: $id) {
            typeDefinitionAttributeList (typeDefinitionIndex: $typeDefinitionIndex) {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
